import { render } from "./Upsells.vue?vue&type=template&id=a1fc853e&scoped=true"
import script from "./Upsells.vue?vue&type=script&lang=js"
export * from "./Upsells.vue?vue&type=script&lang=js"

import "./Upsells.vue?vue&type=style&index=0&id=a1fc853e&scoped=true&lang=css"

import exportComponent from "/home/cleanbee/web/admin.cleanbee.lt/public_html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a1fc853e"]])

export default __exports__